import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import { categories } from "@/mocks/gua";

export default function CategorySection() {
  return (
    <section className="bg-background-50 py-16 md:py-20">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <SectionHeading
            eyebrow="主题分类"
            title="按脉络找瓜，别只看片段"
            desc="把同一时间线的消息串成完整脉络，四条主线覆盖从旧闻重读到实时热议的全部内容。"
          />
          <Link
            to="/heji"
            className="flex w-fit items-center gap-1.5 rounded-md border border-background-300 px-4 py-2.5 text-sm text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-700 whitespace-nowrap"
          >
            查看全部分类
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {categories.map((cat, idx) => (
            <Link
              key={cat.id}
              to={`/heji?cat=${cat.id}`}
              className={`group flex flex-col rounded-xl border p-6 transition-colors ${
                idx === 0
                  ? "border-primary-200 bg-primary-50 hover:border-primary-400"
                  : "border-background-200 bg-background-50 hover:border-accent-300"
              }`}
            >
              <span
                className={`flex h-12 w-12 items-center justify-center rounded-xl ${
                  idx === 0 ? "bg-primary-500 text-background-50" : "bg-accent-100 text-accent-700"
                }`}
              >
                <i className={`${cat.icon} text-2xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">
                {cat.name}
              </h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">
                {cat.desc}
              </p>
              <span className="mt-4 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-500">
                已收录 {cat.count} 条
                <i className="ri-arrow-right-up-line text-base transition-transform group-hover:translate-x-0.5"></i>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}